/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pronunciation_Report_SendInputs */

const en_pronunciation_report_send = /** @type {(inputs: Pronunciation_Report_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Send report`)
};

const es_pronunciation_report_send = /** @type {(inputs: Pronunciation_Report_SendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enviar reporte`)
};

/**
* | output |
* | --- |
* | "Send report" |
*
* @param {Pronunciation_Report_SendInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const pronunciation_report_send = /** @type {((inputs?: Pronunciation_Report_SendInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pronunciation_Report_SendInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_pronunciation_report_send(inputs)
	return en_pronunciation_report_send(inputs)
});